module.exports = __webpack_public_path__ + "static/media/36mostbeautiful2.844b213f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/36mostbeautiful2.png
// module id = 129
// module chunks = 0